<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            optionList: options$ | async,
            disabled: disabled.$ | async,
            values: values.$ | async,
        } as data"
    >
        <ng-container *ngIf="ngControl.control; let control">
            <div
                [class]="'bazis-control bazis-select-during-date-control ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--invalid': ngControl.control.invalid,
                    'bazis-control--disabled': data.disabled,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty':
                        emptyValues.indexOf(dateInterval.value?.dt_start) > -1 &&
                        emptyValues.indexOf(dateInterval.value?.dt_finish) > -1,
                }"
                clickOutside
                (clickOutside)="hideDropdown()"
                [excludeElements]="[dateStartCpm, dateFinishCpm]"
            >
                <bazis-label
                    [id]="attrId"
                    [isMajor]="hasTitleMajor"
                    [isEmptyLabel]="isEmptyLabel"
                    [title]="title || t(titleKey, titleParams)"
                    [required]="data.required"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="data.disabled"
                >
                    <bazis-control-field-start
                        [icon]="icons.date"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <bazis-select-native
                            [attrId]="attrId"
                            [options]="data.optionList"
                            placeholder="placeholder..."
                            [hasOther]="true"
                            [textOther]="t('during.other')"
                        ></bazis-select-native>

                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            aria-hidden="true"
                        >
                            <div
                                class="bazis-select__trigger"
                                (click)="toggleList()"
                                *ngIf="selectedValues$ | async as selectedValues"
                            >
                                <!-- <pre>{{ selectedValues | json }}</pre> -->
                                <ng-container
                                    *ngFor="let selected of selectedValues; let i = index"
                                >
                                    <ng-container *ngIf="selected.$snapshot.name">
                                        {{ selected.$snapshot.name }}
                                    </ng-container>
                                    <ng-container *ngIf="selected.$snapshot.nameKey">
                                        {{
                                            t(
                                                selected.$snapshot.nameKey,
                                                selected.$snapshot.nameParams
                                            )
                                        }}
                                    </ng-container>
                                    {{ i < selectedValues.length - 1 ? ',' : '' }}
                                </ng-container>

                                <!-- вывод даты -->
                                <ng-container *ngIf="isDateApply">
                                    <ng-container *ngIf="dateInterval.value.dt_start">
                                        {{ dateInterval.value.dt_start | localDate: 'shortDate' }}
                                    </ng-container>
                                    <ng-container *ngIf="dateInterval.value.dt_finish">
                                        -
                                        {{ dateInterval.value.dt_finish | localDate: 'shortDate' }}
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <bazis-control-select-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (toggled)="toggleList()"
                    >
                    </bazis-control-select-end>

                    <ul
                        class="bazis-list bazis-list_control-dd"
                        [hidden]="!showList"
                    >
                        <li
                            class="bazis-item"
                            *ngFor="let option of data.optionList"
                            [class.bazis-item--selected]="data.values.indexOf(option.id) > -1"
                            (click)="toggleValue(option.id)"
                        >
                            <span>
                                <ng-container *ngIf="option.$snapshot.name">
                                    {{ option.$snapshot.name }}
                                </ng-container>
                                <ng-container *ngIf="option.$snapshot.nameKey">
                                    {{ t(option.$snapshot.nameKey, option.$snapshot.nameParams) }}
                                </ng-container>
                            </span>
                        </li>

                        <li
                            class="bazis-item"
                            [class.bazis-item--selected]="isDateApply"
                            (click)="toggleValue('other')"
                        >
                            {{ t('during.other') }}
                        </li>
                    </ul>

                    <div
                        class="bazis-dropdown__body bh-popper-z-index"
                        [hidden]="!showDate && !forceDateSelection"
                    >
                        <bazis-grid
                            class="bazis-grid_form"
                            [formGroup]="dateInterval"
                        >
                            <bazis-row>
                                <bazis-col size="6">
                                    <bazis-input-date
                                        formControlName="dt_start"
                                        [titleKey]="startDateTitleKey"
                                        [popperOptions]="popperOptions"
                                        [placeIcon]="placeIcon"
                                        [placeholderKey]="dateFromPlaceholderKey"
                                        [mode]="mode"
                                        #dateStartCpm
                                    ></bazis-input-date>
                                </bazis-col>
                                <bazis-col size="6">
                                    <bazis-input-date
                                        formControlName="dt_finish"
                                        [titleKey]="endDateTitleKey"
                                        [popperOptions]="popperOptions"
                                        [placeIcon]="placeIcon"
                                        [placeholderKey]="dateToPlaceholderKey"
                                        [mode]="mode"
                                        #dateFinishCpm
                                    ></bazis-input-date>
                                </bazis-col>
                            </bazis-row>
                        </bazis-grid>
                        <bazis-display-error
                            *ngIf="dateInterval.errors?.invalidIntervalDate"
                            errorKey="invalidIntervalDate"
                        ></bazis-display-error>

                        <bazis-button
                            class="bh-block bh-margin-top-3x"
                            color="action"
                            [disabled]="
                                dateInterval.invalid ||
                                (!dateInterval.controls['dt_start'].value &&
                                    !dateInterval.controls['dt_finish'].value)
                            "
                            (click)="dateApply()"
                        >
                            {{ t('title.apply') }}
                        </bazis-button>
                    </div>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ noteKey }}
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
